import { TProps } from './types/TProps';
import { Wrapper } from './styles/Wrapper';

export const CheckBox = ({ checked, onChange, rounded, disabled, className = 'checkbox' }: TProps) => (
  <Wrapper className={className} rounded={rounded} disabled={disabled}>
    <input type="checkbox" checked={checked} onChange={() => {}} />
    <span onClick={() => !disabled && onChange(!checked)} className="checkmark"></span>
  </Wrapper>
);
